<template>
  <div ref="studentsPage">
    <div class="w-full">
      <payment-sidebar :isSidebarActive="paymentSidebar" :selectedStudent="selectedStudent" @saveData="paymentAdded" @closeSidebar="paymentSidebar = false" />
      <vx-card id="studentsCard" ref="students" title="Students" v-show="!isStudentListHidden">        
        <vs-table :sst="true" @search="handleSearch" @change-page="handleChangePage" stripe ref="studentsTable" class="vs-con-loading__container" single @selected="handleSelectedStudent" pagination :max-items="pageSize" search :data="students"> <!-- @sort="handleSort" -->
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
            <!-- ADD NEW -->
            <div ref="addNew" class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewStudent">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>
            <div>
              <vs-checkbox v-model="showInactive" color="warning">Show Inactive Students</vs-checkbox>
            </div>
          </div>
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Mobile Number</vs-th>
            <vs-th>ID Number</vs-th>
            <vs-th>Email</vs-th>
            <vs-th>Company</vs-th>
            <vs-th>Balance</vs-th>
            <!-- <vs-th sort-key="userFirstName">Name</vs-th>
            <vs-th sort-key="mobile">Mobile Number</vs-th>
            <vs-th sort-key="idNumber">ID Number</vs-th>
            <vs-th sort-key="email">Email</vs-th>
            <vs-th sort-key="companyName">Company</vs-th>
            <vs-th sort-key="amountOwed">Balance</vs-th> -->
            <vs-th></vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="student" :state="student.isActive == false ? 'warning':null" :key="indextr" v-for="(student, indextr) in data" >

              <vs-td :data="data[indextr].userFirstName">
                {{ student.userFirstName + " " + student.userLastName }}
              </vs-td>

              <vs-td :data="data[indextr].mobile">
                {{ student.mobile }}
              </vs-td>

              <vs-td :data="data[indextr].idNumber">
                {{ student.idNumber }}
              </vs-td>

              <vs-td :data="data[indextr].email">
                {{ student.email }}
              </vs-td>

              <vs-td :data="data[indextr].companyName">
                {{ student.companyName || 'N/A' }}
              </vs-td>

              <vs-td :data="data[indextr].amountOwed" :style="{ color: student.amountOwed < 0 ? 'rgb(255, 0, 0)' : student.amountOwed > 0 ? 'rgb(0, 128, 0)' : ''}">
                {{ "R " + Number(student.amountOwed).toLocaleString('en') }}
              </vs-td>

              <vs-td>
                <vs-button size="small" :color="student.amountOwed < 0 ? 'success' : 'primary'" @click.stop.prevent="addPayment(student)">Add Payment</vs-button>
              </vs-td>

              <vs-td>
                <vs-button color="success" type="border" size="small" @click.stop.prevent="showTransactionsPopup(student)">View Transactions</vs-button>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div>
      <vx-card id="studentInfoCard" class="vs-con-loading__container" ref="studentInfo" v-show="!isInfoHidden">

        <div slot="no-body" class="tabs-container px-3 pt-2">
          <vs-tabs v-model="activeTab">
            <vs-tab label="Information">
              <div class="tab-text">
                <div v-show="formData.modifiedOn" class="vx-row">
                  <div class="vx-col sm:w-2/2 w-full" style="text-align: right; position: absolute;">
                    <small><label>Last modified on <strong>{{ formData.modifiedOn.replace("T", " ").split('.')[0] }}</strong> by <strong>{{ formData.modifiedBy }}</strong></label></small>
                  </div>
                </div>
                <div id="profilerow" class="vx-row mt-4 ml-4">
                  <div class="vx-col w-1/5 profile-container cursor-pointer" @click="showUpload">
                    <img id="profileimg" v-bind:src="formData.uploadedFileName" v-show="formData.uploadedFileName" width="100%" class="cursor-pointer">
                    <div v-if="formData.uploadedFileName" class="overlay cursor-pointer">
                      <div class="text">Click to change image</div>
                    </div>
                    <div class="flex flex-wrap items-center vs-con-loading__container justify-center pb-4">
                      <v-uploader id="pictureuploader" ref="fileUpload" @done="successUpload" v-show="!formData.uploadedFileName" file-type-exts="jpeg,jpg,png" button-text="Upload Profile Picture" language="en" file-size-limit="10MB" :preview="false"></v-uploader>
                    </div>
                  </div>
                  <div class="vx-row pb-3 ml-4">
                    <div class="vx-col w-full">
                      <h2>{{ formData.userFirstName }} {{ formData.userLastName }}</h2>
                      <h5 v-if="formData.email">Email: <strong>{{ formData.email }}</strong></h5>
                      <h5 v-if="formData.mobile">Mobile: <strong>{{ formData.mobile }}</strong></h5>
                      <h5 v-if="formData.work">Work: <strong>{{ formData.work }}</strong></h5>
                    </div>
                  </div>
                </div>
                <vs-divider class="mb-6">Information</vs-divider>
                <div class="vx-row pb-3">
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <label>First Name</label>
                    <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required|alpha_spaces'" name="First Name" icon-pack="feather" icon="icon-user" v-model="formData.userFirstName" />
                    <span class="text-danger text-sm" v-show="errors.has('First Name')">{{ errors.first('First Name') }}</span>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <label>Last Name</label>
                    <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required|alpha_spaces'" name="Last Name" icon-pack="feather" icon="icon-user" v-model="formData.userLastName" />
                    <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>
                  </div>
                </div>
                <div class="vx-row pb-3">
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <label>Work Phone</label>
                    <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'digits:10'" name="Work Phone" icon-pack="feather" icon="icon-phone" v-model="formData.work" />
                    <span class="text-danger text-sm" v-show="errors.has('Work Phone')">{{ errors.first('Work Phone') }}</span>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <label>Mobile</label>
                    <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required|digits:10'" name="Mobile" icon-pack="feather" icon="icon-smartphone" v-model="formData.mobile" />
                    <span class="text-danger text-sm" v-show="errors.has('Mobile')">{{ errors.first('Mobile') }}</span>
                  </div>
                </div>
                <div class="vx-row pb-3">
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <label>Identification Number or Passport Number</label>
                    <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'alpha_num'" name="ID Number" icon-pack="feather" icon="icon-hash" v-model="formData.idNumber" />
                  </div>
                </div>
                <div class="vx-row pb-3" v-show="currentSiteTypeId == 1">
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <label>Content Language</label>
                    <v-select ref="languageDropdown" class="w-full" placeholder="Search / Select Language" :options="languages" v-model="languageDropdown" @search:blur="selectLanguage"></v-select>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <label>Grade</label>
                    <v-select ref="classificationDropdown" class="w-full" placeholder="Search / Select Grade" :options="classifications" v-model="classificationDropdown"></v-select>
                  </div>
                </div>
                <div class="vx-row pb-3">
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <label>Email</label>
                    <vs-input autocomplete="off" icon-no-border ref="emailInput" @blur="evaluateStudent" onClick="this.select();" v-validate="'required|email'" name="email" class="w-full" icon-pack="feather" icon="icon-at-sign" v-model="formData.email" />
                    <!-- <vs-input autocomplete="off" icon-no-border ref="emailInput" onClick="this.select();" @blur="evaluateStudent" v-validate="'required|email'" name="email" class="w-full" icon-pack="feather" icon="icon-at-sign" v-model="formData.email" /> -->
                    <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <label>Password</label>
                    <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'min:8'" name="password" icon-pack="feather" icon="icon-lock" v-model="formData.password" />
                    <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
                  </div>
                  <!-- <div class="vx-col mb-2 mt-8">
                    <vs-checkbox v-model="formData.isActive" color="success">Is Active</vs-checkbox>
                  </div> -->
                </div>
                <vs-divider class="mb-6 pt-0">Signature</vs-divider>
                <div class="vx-col cropper-div">
                  <input
                    ref="input"
                    type="file"
                    name="image"
                    accept="image/*"
                    @change="setImage"
                  />
                  <section class="cropper-area_tool">
                    <div class="img-cropper">
                      <vue-cropper
                        v-show="formData.signatureImageUrl && newSignatureClicked"
                        ref="cropper"
                        :src="formData.signatureImageUrl"
                        preview=".preview"
                      />
                    </div>
                    <img v-if="signature && !newSignatureClicked" :src="signature" />
                  </section>
                  <div class="vx-vol cropper-area_buttons">
                    <div class="vx-row ml-0">
                      <vs-button class="mr-5 mt-3 new-signature-button-on-select" color="success" type="filled" icon-pack="feather" icon="icon-upload" @click.prevent="showFileChooser">Upload New Signature</vs-button>

                      <vs-button v-show="newSignatureClicked" class="mr-5 mt-3" type="border" color="warning" icon-pack="feather" icon="icon-refresh-ccw" @click.prevent="reset">Reset</vs-button>

                      <vs-button v-show="newSignatureClicked" radius class="mr-2 mt-3" icon-pack="feather" icon="icon-zoom-in" @click.prevent="zoom(0.2)" />
                      <vs-button v-show="newSignatureClicked" radius class="mr-5 mt-3" icon-pack="feather" icon="icon-zoom-out" @click.prevent="zoom(-0.2)" />

                      <vs-button v-show="newSignatureClicked" radius type="border" class="mr-2 mt-3" icon-pack="feather" icon="icon-arrow-left" @click.prevent="move(-10, 0)" />
                      <vs-button v-show="newSignatureClicked" radius type="border" class="mr-2 mt-3" icon-pack="feather" icon="icon-arrow-right" @click.prevent="move(10, 0)" />
                      <vs-button v-show="newSignatureClicked" radius type="border" class="mr-2 mt-3" icon-pack="feather" icon="icon-arrow-up" @click.prevent="move(0, -10)" />
                      <vs-button v-show="newSignatureClicked" radius type="border" class="mr-5 mt-3" icon-pack="feather" icon="icon-arrow-down" @click.prevent="move(0, 10)" />

                      <vs-button v-show="newSignatureClicked" radius class="mr-2 mt-3" icon-pack="feather" icon="icon-rotate-cw" @click.prevent="rotate(90)" />
                      <vs-button v-show="newSignatureClicked" radius class="mr-5 mt-3" icon-pack="feather" icon="icon-rotate-ccw" @click.prevent="rotate(-90)" />

                      <vs-button v-show="newSignatureClicked" class="mr-5 mt-3" color="success" icon-pack="feather" icon="icon-crop" @click.prevent="cropImage">Crop</vs-button>
                    </div>
                  </div>
                  <p v-show="cropImg" class="mt-3 text-success">Signature cropped. Remember to click <strong>Save</strong>.</p>
                </div>
                <vs-divider v-show="!showModulePart" />
                <div v-show="formData.id && $siteTypeId() != 1">
                  <vs-button v-show="!showModulePart" color="success" @click="showModulePart = true">Load Modules</vs-button>
                </div>

                <div v-show="showModulePart">
                  <vs-divider>Modules</vs-divider>
                  <div id="moduleList">
                    <div>
                      <vs-button icon-pack="feather" @click.stop.prevent="populateModule()">Load Modules</vs-button>
                    </div>
                    <vs-table 
                      ref="allUnassignedModule" 
                      class="vs-con-loading__container" 
                      stripe 
                      single 
                      pagination 
                      max-items="10" 
                      search 
                      :data="unassignedModules">
                      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                        <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
                          <h3 class="ml-2">Ready-to-Assign</h3>
                        </div>
                      </div>
                      <template slot="thead">
                        <vs-th sort-key="userFirstName">Course</vs-th>
                        <vs-th sort-key="mobile">Module</vs-th>
                        <vs-th>Assign</vs-th>
                      </template>

                      <template slot-scope="{data}">
                        <vs-tr :data="unassignedModules" :state="unassignedModules.assigned == false ? 'warning' : null" :key="indextr" v-for="(mod, indextr) in data">

                          <vs-td :data="data[indextr].courseName">
                            {{ mod.courseName }}
                          </vs-td>

                          <vs-td :data="data[indextr].moduleName">
                            {{ mod.moduleName }}
                          </vs-td>

                          <vs-td>
                            <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assign(mod.moduleId)"></vs-button>
                          </vs-td>

                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                  <vs-table id="modulesTable" ref="modulesTable" class="vs-con-loading__container" single pagination max-items="10" search :data="assignedModules">
                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                      <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
                        <h3 class="ml-2">Already Assigned</h3>
                      </div>
                    </div>
                    <template slot="thead">
                      <vs-th sort-key="courseName">Course</vs-th>
                      <vs-th sort-key="moduleName">Module</vs-th>
                      <vs-th></vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :data="assignedModules" :key="indextr" v-for="(mod, indextr) in data" >

                        <vs-td :data="data[indextr].courseName">
                          {{ mod.courseName }}
                        </vs-td>

                        <vs-td :data="data[indextr].moduleName">
                          {{ mod.moduleName }}
                        </vs-td>

                        <vs-td>
                          <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="areYouSure(mod.moduleId)"></vs-button>
                        </vs-td>

                      </vs-tr>
                    </template>
                  </vs-table>
                  <vs-divider></vs-divider>
                </div>

                <div class="vx-row">
                  <vs-spacer></vs-spacer>
                  <vs-button v-if="formData.id" color="danger" icon-pack="feather" @click.prevent="removeStudent" class="mb-2" ref="deleteButton" icon="icon-trash">Delete</vs-button>
                  <div class="vx-col">
                    <vs-button :disabled="busy" color="success" class="mr-3 mb-2 vs-con-loading__container" @click.prevent="saveEditStudent" ref="saveEditButton">Save</vs-button>
                    <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#studentInfoCard'" @click="cancelAdd">{{ formData.id ? "Close" : "Cancel" }}</vs-button> 
                  </div>
                </div>
              </div>
            </vs-tab>
            <vs-tab label="Module Progress">
              <div class="tab-text">
                <student-progress @cancelAdd="cancelAdd" :studentId="formData.id" class="mt-4" />
              </div>
            </vs-tab>
            <vs-tab label="Documents">
              <div class="tab-text">
                <student-document @cancelAdd="cancelAdd" :studentId="formData.id" class="mt-4" />
              </div>
            </vs-tab>
          </vs-tabs>
        </div>
      </vx-card>
    </div>

    <vs-popup id="transactionsPopup" ref="transactionsPopup" :title="`${'Transactions for'} ${studentTrans.name}`" :active.sync="transactionsPopupActive">
      <div v-if="studentTrans && studentTrans.transactions.length > 0">
        <table id="transactionTable" style="width: 100%;" > 
          <tr>
            <th>Reason</th>
            <th>Amount</th>
            <th>Date</th>
          </tr>
          <tr class="ml-0" v-for="(item, index) in studentTrans.transactions" :key="index">
            <td>
              {{ item.transactionType }}
            </td>
            <td :style="{ color: item.amount < 0 ? 'rgb(255, 0, 0)' : item.amount > 0 ? 'rgb(0, 128, 0)' : ''}">
              {{ "R " + Number(item.amount).toLocaleString('en') }}
            </td>
            <td>
              {{ item.createdOn.replace("T", " ").split('.')[0] }}
            </td>
          </tr>
        </table>

        <div class="vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col" style="display: flex;">
            <vs-button class="mt-4" icon-pack="feather" icon="icon-copy" @click="selectElementContents('transactionTable')">Copy to Clipboard</vs-button>
            <vs-button class="mt-4 ml-4" color="success" icon-pack="feather" icon="icon-download" @click="exportTransactionsToExcel">Download .csv</vs-button>
          </div>
        </div>
      </div>
      <div v-else>
        <p style="text-align-last: center;">No transactions yet...</p>
      </div>
    </vs-popup>

  </div>

</template>

<script>
  import vSelect from 'vue-select'
  import StudentProgress from './StudentProgress.vue'
  import StudentDocument from './StudentDocuments.vue'
  import PaymentSidebar from './PaymentSidebar.vue';
  import VueCropper from 'vue-cropperjs';
  import 'cropperjs/dist/cropper.css';
  export default {
    components: {
      'v-select': vSelect,
      StudentProgress,
      PaymentSidebar,
      StudentDocument,
      VueCropper
    },
    data() {
      return {
        showModulePart: false,
        pageSize: 10,
        headerTitleTrans: ["Reason","Amount","Date"],
        headerValTrans: ["transactionType","amount","createdOn"],
        transactionsPopupActive: false,
        paymentSidebar: false,
        selectedStudent: {},
        modulesDropdown: 0,
        loadingColor:'#fff',
        selected: [],
        isInfoHidden: true,
        isStudentListHidden: false,
        students: [],
        sites: [],
        formData: {
          id: 0,
          userFirstName: "",
          userLastName: "",
          work: "",
          mobile: "",
          email: "",
          password: "",
          isActive: true,
          site: [],
          uploadedFileName: "",
          isStudent: true,
          idNumber: "",
          modifiedOn: "",
          modifiedBy: "",
          languageId: null,
          courseClassificationId: null,
          signatureImageUrl: "",
          guardianId: null
        },
        showInactive: false,
        existingStudent: [],
        mode: "",
        currentSite: "",
        currentStudent: {},
        isLoading: false,
        unassignedModules: [],
        assignedModules: [],
        moduleId: 0,
        activeTab: 0,
        studentTrans: {
          id: 0,
          name: "",
          transactions: []
        },
        criteria: {
          pageSize: 0,
          pageNumber: 0,
          sortKey: "",
          sortOrder: "",
          searchPhrase: "",
          showInactive: false
        },
        languageDropdown: 0,
        classificationDropdown: 0,
        languages: [],
        classifications: [],
        currentSiteTypeId: null,
        busy: false,
        cropImg: null,
        newSignatureClicked: false,
        signature: ""
      }
    },
    watch: {
      showInactive: function(val) {
        this.criteria.showInactive = val;
        this.loadStudentData();
      },
      showModulePart: function(val) {
        if(val) {
          this.GetAssignedModules(this.formData.id);
        }
      }
    },
    methods: {
      evaluateStudent() {
        var self = this;
        if(self.formData.email){
          if(this.mode == "Add Student"){
            self.$validator.validate('email').then(result => {
              if (result) {
                var onSuccess = response => {
                  self.existingStudent = response.data;
                  if (self.existingStudent != null){
                    self.openConfirm();
                  }
                };
                self.formData.email = self.formData.email.toLowerCase();
                self.formData.isActive = true;
                
                self.$ajaxGet(self, "student/evaluatestudent/" + self.formData.email, onSuccess);
              }
            });
          }
        }
      },
      initValues() {
        this.modulesDropdown = 0;
        this.formData.id = 0;
        this.formData.userFirstName = "";
        this.formData.userLastName = "";
        this.formData.work = "";
        this.formData.mobile = "";
        this.formData.email = "";
        this.formData.password = "";
        this.formData.isActive = true;
        this.formData.uploadedFileName = "";
        this.formData.idNumber = "";
        this.formData.modifiedOn = "";
        this.formData.modifiedBy = "";
        this.formData.languageId = null;
        this.formData.courseClassificationId = null;
        this.formData.signatureImageUrl = "";
        this.formData.guardianId = null;
        this.mode = "";
        this.isLoading = false;
        this.unassignedModules = [];
        this.assignedModules = [];
        this.errors.clear();
        this.moduleId = 0;
        this.activeTab = 0;

        this.studentTrans.id = 0;
        this.studentTrans.name = "";
        this.studentTrans.transactions = [];

        this.showModulePart = false;

        this.languageDropdown = 0;
        this.classificationDropdown = 0;
        this.busy = false;

        this.$validator.errors.clear();
        this.cropImg = null;
        this.newSignatureClicked = false;
        this.signature = "";
      },
      selectLanguage() {
        var self = this;
        if (self.languageDropdown)
          self.getClassifications();
      },
      getLanguages(whenDone) {
        var self = this;

        var onSuccess = response => {
          self.languages = response.data.map((item) => {return {label: item.text, value: item.value} });
          if (whenDone && typeof whenDone == "function")
            whenDone();
        };
        
        self.$ajaxGet(self, "language/GetSelectList", onSuccess);
      },
      getClassifications(whenDone) {
        var self = this;

        var onSuccess = response => {
          self.classifications = response.data.map((item) => { return { label: item.text, value: item.value } });
          if (whenDone && typeof whenDone == "function")
            whenDone();
        };

        self.$ajaxGet(self, "courseclassification/GetSelectList/" + self.languageDropdown.value, onSuccess);
      },
      cancelAdd() {
        this.initValues();
        this.isInfoHidden = true;
        this.isStudentListHidden = false;
        this.loadStudentData();
      },
      addNewStudent() {
        this.initValues();
        this.isStudentListHidden = true;
        this.isInfoHidden = false;
        this.mode = "Add Student";
      },
      selectElementContents(elId) {
        var el = document.getElementById(elId);
        var body = document.body, range, sel;
        if (document.createRange && window.getSelection) {
          range = document.createRange();
          sel = window.getSelection();
          sel.removeAllRanges();
          try {
            range.selectNodeContents(el);
            sel.addRange(range);
          } catch (e) {
            range.selectNode(el);
            sel.addRange(range);
          }
          document.execCommand("copy");
          this.$vs.notify({
            color: "success",
            text: "Copied!",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-clipboard"
          });
        } else if (body.createTextRange) {
          range = body.createTextRange();
          range.moveToElementText(el);
          range.select();
          range.execCommand("Copy");
          this.$vs.notify({
            color: "success",
            text: "Copied!",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-clipboard"
          });
        }
        sel.removeAllRanges();
      },
      exportTransactionsToExcel() {
        var self = this;
        import('@/vendor/Export2Excel').then(excel => {
          const list = self.studentTrans.transactions;
          const data = self.formatJson(self.headerValTrans, list);
          var date = new Date();
          excel.export_json_to_excel({
            header: self.headerTitleTrans,
            data,
            filename: `Transactions for ${self.studentTrans.name} (${date.getDate()}-${date.getMonth()}-${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()})`,
            autoWidth: false,
            bookType: "csv"
          })
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => {
          return v[j]
        }))
      },
      loadStudentData() {
        const self = this;
        self.showLoadingOnTable();

        var onSuccess = function (response) {
          self.students = [];

          if(self.criteria.pageNumber > 1)
            self.students[((self.criteria.pageNumber - 1) * self.pageSize) - 1] = {};
          
          self.students = self.students.concat(response.data.records);
          
          if(response.data.count > (self.criteria.pageNumber * self.pageSize))
            self.students[response.data.count - 1] = {};
        };
        var onFinally = function () {
          if (self.$refs.studentsTable)
            self.$vs.loading.close(self.$refs.studentsTable.$el);
        };

        self.$ajaxPost(self, "Student/GetStudentsSst", self.criteria, onSuccess, onFinally);
      },
      getCurrentStudent() {
        var self = this;
        var onSuccess = function (response) {
          self.currentStudent = response.data;
        };
        self.$ajaxGet(self, "user/GetCurrentUserInfo", onSuccess);
      },
      removeStudent(){
        var self = this;
        self.showLoadingOnDeleteButton()
        var onSuccess = function (response) {
          self.busy = false;
          self.initValues();
          self.isInfoHidden = true;
          self.isStudentListHidden = false;
          self.loadStudentData();
          self.$vs.loading.close(self.$refs.deleteButton.$el);
        };
        self.$ajaxGet(self, "Student/removeStudent?id="+ this.formData.id, onSuccess);
      },
      handleSelectedStudent(student) {
        var self = this;

        this.mode = "Edit Student";
        this.activeTab = 0;
        this.isStudentListHidden = true;
        this.isInfoHidden = false;

        this.$refs.fileUpload.$el.addEventListener("click", function(){
          if(!self.isLoading)
            self.showLoadingOnUploader();
          else{
            self.isLoading = false;
            self.$vs.loading.close(self.$refs.fileUpload.$el);
          }
        });

        this.formData.id = student.id;
        this.formData.userFirstName = student.userFirstName;
        this.formData.userLastName = student.userLastName;
        this.formData.work = student.work;
        this.formData.mobile = student.mobile;
        this.formData.uploadedFileName = student.imageUrl;
        this.formData.email = student.email;
        this.formData.password = student.password;
        this.formData.isActive = student.isActive;
        this.formData.idNumber = student.idNumber;
        this.formData.modifiedOn = student.modifiedOn;
        this.formData.modifiedBy = student.modifiedBy;
        this.formData.signatureImageUrl = student.signatureImageUrl;
        this.signature = student.signatureImageUrl;
        this.formData.site = JSON.parse(localStorage.getItem('userSiteInfo'))[0];
        if (self.$siteTypeId() == 1) {
          this.getLanguages(function() {
            if (student.languageId) {
              self.languageDropdown = self.languages.filter(function(item){return item.value == student.languageId;})[0];
            
              self.getClassifications(function() {
                self.classificationDropdown = self.classifications.filter(function(item){return item.value == student.courseClassificationId;})[0];
              })
            }
          })
        }
      },
      saveEditStudent() {
        var self = this;
        self.signature = null;
        self.$validator.validateAll().then(result => {
          if (result) {
            self.showLoadingOnSaveButton();
            self.busy = true;
            self.formData.email = self.formData.email.toLowerCase();
            self.formData.isActive = true;
            self.formData.languageId = self.languageDropdown ? parseInt(self.languageDropdown.value) : null;
            self.formData.courseClassificationId = self.classificationDropdown ? parseInt(self.classificationDropdown.value) : null;

            self.formData.guardianId = self.$route.query.id || null;

            var onSuccess = response => {
              if (self.$route.query.id) {
                self.$vs.notify({
                  title:'Information',
                  color: "success",
                  text: "Student Saved & Linked to Guardian",
                  position:'top-right',
                  iconPack: 'feather',
                  icon:'icon-save'
                });
                self.$router.push({ name: "GuardiansList", query: { id: self.$route.query.id } });
              } else {
                self.formData.id = response.data;
                self.cropImg = null;
                self.newSignatureClicked = false;
                self.signature = self.formData.signatureImageUrl;
                self.$refs.cropper.destroy();
                self.$vs.notify({
                  title:'Information',
                  color: "success",
                  text: "Student Saved",
                  position:'top-right',
                  iconPack: 'feather',
                  icon:'icon-save'
                });
                this.initValues();
                this.isInfoHidden = true;
                this.isStudentListHidden = false;
                this.loadStudentData();
              }
            };
            var onFinally = function () {
              self.busy = false;

              if (self.$refs.saveEditButton)
                self.$vs.loading.close(self.$refs.saveEditButton.$el);
            };
            
            self.$ajaxPost(self, "student/addeditstudent", self.formData, onSuccess, onFinally);
          } else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        });
      },
      successUpload(data) {
        this.formData.uploadedFileName = data[0].url;
        this.$vs.loading.close(this.$refs.fileUpload.$el);
        this.isLoading = false;
      },
      showUpload() {
        this.formData.uploadedFileName = null;
      },
      GetAssignedModules(studentId) {
        const self = this;
        self.showLoadingOnModulesTable();

        var onSuccess = function (response) {
          self.assignedModules = response.data.filter(function(item) {
            return item.isAssigned;
          });
          self.unassignedModules = response.data.filter(function(item) {
            return !item.isAssigned;
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.modulesTable.$el);
          self.$refs.modulesTable.searchx = "";
        };

        self.$ajaxGet(self, "student/GetAssignedModules?studentId=" + studentId, onSuccess, onFinally);
      },
      populateModule(){
        var self = this;
        self.GetAssignedModules(self.formData.id);
      },
      assign(moduleId) {
        var self = this;
        self.showLoadingOnAllUnassignedModule();
        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Student Assigned to Module",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-user-check'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.allUnassignedModule.$el);
          self.GetAssignedModules(self.formData.id);
          self.modulesDropdown = 0;
        };

        self.$ajaxGet(self, "StudentModule/AssignToModule?studentId=" + self.formData.id + "&moduleId=" + moduleId, onSuccess, onFinally);

      },
      areYouSure(moduleId) {
        this.moduleId = moduleId;
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Attention`,
          text: 'Are you sure you want to remove the selected module from the student?',
          accept: this.unassign,
          acceptText: "Yes",
          cancelText: "No"
        })
      },
      unassign() {
        var self = this;
        self.showLoadingOnModulesTable();

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Student Unassigned from Module",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-user-minus'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.modulesTable.$el);
          self.GetAssignedModules(self.formData.id);
        };

        self.$ajaxGet(self, "StudentModule/DeactivateFromModule?studentId=" + self.formData.id + "&moduleId=" + self.moduleId, onSuccess, onFinally);
      },
      addPayment(student) {
        this.paymentSidebar = true;
        this.selectedStudent = student;
      },
      paymentAdded() {
        this.paymentSidebar = false;
        this.loadStudentData();
      },
      showTransactionsPopup(student) {
        var self = this;

        self.studentTrans.id = 0;
        self.studentTrans.name = "";
        self.studentTrans.transactions = [];
        
        self.getTransactions(student);
      },
      getTransactions(student) {
        const self = this;
        self.showLoadingOnElement("studentsPage", 1, "corners");

        var onSuccess = function (response) {
          self.studentTrans.id = student.id;
          self.studentTrans.name = `${student.userFirstName} ${student.userLastName}`;
          self.studentTrans.transactions = response.data;

          self.transactionsPopupActive = true;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.studentsPage.$el);
        };

        self.$ajaxGet(self, "Student/ListTransactions?studentId=" + student.id, onSuccess, onFinally);
      },
      showLoadingOnModulesTable() {
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.modulesTable.$el,
          scale: 1
        });
      },
      showLoadingOnAllUnassignedModule() {
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.allUnassignedModule.$el,
          scale: 1
        });
      },
      showLoadingOnSaveButton(){
        var self = this;
        self.$vs.loading({
          type: "material",
          container: self.$refs.saveEditButton.$el,
          scale: 0.45
        });
      },
      showLoadingOnDeleteButton(){
        var self = this;
        self.$vs.loading({
          type: "material",
          container: self.$refs.deleteButton.$el,
          scale: 0.45
        });
      },
      showLoadingOnAddNewCard(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.studentInfo.$el,
          scale: 1
        });
      },
      showLoadingOnTable(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.studentsTable.$el,
          scale: 1
        });
      },
      showLoadingOnUploader(){
        var self = this;
        self.isLoading = true;
        self.$vs.loading({
          type: "material",
          container: self.$refs.fileUpload.$el,
          scale: 0.45
        });
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      scrollToNavbar(elementId) {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById(elementId), 500, scrollOptions);
      },
      openConfirm() {
        var self = this;
        if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
          self.currentSite = JSON.parse(localStorage.getItem('userSiteInfo'))[0].name
        else
          self.currentSite = JSON.parse(localStorage.getItem('userSiteInfo')).name
        
        self.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: `Email Already Exists`,
          text: 'The email address (' + self.existingStudent.email + ') seems to already exist for \'' + self.existingStudent.displayName + '\'.\n\nBy choosing \'Accept\', you\'ll allow \'' + self.existingStudent.displayName + '\' to gain access to your current site: ' + self.currentSite + '.',
          accept: self.acceptAlert
        })
      },
      acceptAlert() {
        const self = this;
        var student = [];
        self.showLoadingOnAddNewCard();

        var onSuccess = function (response) {
          student = response.data;
          self.formData.id = student.id;
          self.formData.userFirstName = student.userFirstName;
          self.formData.userLastName = student.userLastName;
          self.formData.work = student.work;
          self.formData.mobile = student.mobile;
          self.formData.uploadedFileName = student.imageUrl;
          self.formData.email = student.email;
          self.formData.isActive = student.isActive;
          self.formData.idNumber = student.idNumber;
          self.formData.site = JSON.parse(localStorage.getItem('userSiteInfo'))[0];
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.studentInfo.$el);
        };

        self.$ajaxGet(self, "student/LinkExistingStudentToNewSite/" + self.existingStudent.userId, onSuccess, onFinally);
      },
      handleSearch(searchPhrase) {
        var self = this;

        if(searchPhrase.length >= 3){
          self.criteria.searchPhrase = searchPhrase;
          self.criteria.showInactive = self.showInactive;

          self.loadStudentData();
        }
        else if (searchPhrase == ""){
          self.criteria.searchPhrase = searchPhrase;
          self.loadStudentData();
        }
      },
      handleChangePage(pageNumber) {
        var self = this;

        if(pageNumber > 0) {
          self.criteria.pageNumber = pageNumber;
          self.criteria.showInactive = self.showInactive;

          self.loadStudentData();
        }
      },
      handleSort(sortKey, sortOrder) {
        var self = this;

        self.criteria.sortKey = sortKey;
        self.criteria.sortOrder = sortOrder;
        self.criteria.showInactive = self.showInactive;

        self.loadStudentData();
      },
      cropImage() {
        var self = this;
        self.cropImg = self.$refs.cropper.getCroppedCanvas().toDataURL();

        var fileExt = self.cropImg.substring(
          self.cropImg.indexOf("/") + 1, 
          self.cropImg.indexOf(";")
        );



        var byteString = atob(self.cropImg.split(',')[1]);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);

        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        var blob = new Blob([ab], { type: 'image/' + fileExt });


        
        var data = new FormData();
        data.append('image', blob, "signature_" + self.formData.id + "." + fileExt);

        var onSuccess = response => {
          self.formData.signatureImageUrl = response.data.url;
        };

        self.$ajaxPost(self, "tempupload", data, onSuccess);
      },
      move(offsetX, offsetY) {
        this.$refs.cropper.move(offsetX, offsetY);
      },
      reset() {
        this.cropImg = null;
        this.$refs.cropper.reset();
      },
      rotate(deg) {
        this.$refs.cropper.rotate(deg);
      },
      setImage(e) {
        const file = e.target.files[0];
        if (file.type.indexOf('image/') === -1) {
          alert('Please select an image file');
          return;
        }
        if (typeof FileReader === 'function') {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.formData.signatureImageUrl = event.target.result;
            // rebuild cropperjs with the updated source
            this.$refs.cropper.replace(this.formData.signatureImageUrl);
          };
          reader.readAsDataURL(file);
          this.newSignatureClicked = true;
        } else {
          alert('Sorry, FileReader API not supported');
        }
      },
      showFileChooser() {
        this.$refs.input.click();
      },
      zoom(percent) {
        this.$refs.cropper.relativeZoom(percent);
      },
    },
    mounted() {
      var self = this;

      if (self.$route.query.id) {
        self.addNewStudent();
      }

      if (self.$refs.studentsTable) {
        self.showLoadingOnTable();
      }
      
      if (self.$siteTypeId() == 1)
        self.getLanguages();

      self.criteria.pageSize = self.pageSize;
      self.criteria.pageNumber = self.$refs.studentsTable.currentPage;

      self.loadStudentData();

      if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
        self.currentSiteTypeId = JSON.parse(localStorage.getItem("userSiteInfo"))[0].siteTypeId;
      else
        self.currentSiteTypeId = JSON.parse(localStorage.getItem("userSiteInfo")).siteTypeId;

      window.addEventListener('resize', () => {
        self.reset();
      });
    },
  }

</script>

<style lang="scss">

.new-signature-button-on-select{
    height: fit-content;
    margin-top: 14px;
    margin-right: 2px;
  }

  div#transactionsPopup.vs-component.con-vs-popup.vs-popup-primary {
    div.vs-popup {
      header.vs-popup--header {
        i.vs-icon.notranslate.icon-scale.vs-popup--close.vs-popup--close--icon.material-icons.null {
          background: rgb(253, 0, 0) !important;
          color: rgb(255, 255, 255);
        }
      }
    }
  }

  #profileimg {
    border-radius: 50%;
    padding:2px;
    border:1px solid #838383;
    background-color:rgb(255, 255, 255);
    /* max-width: 100px; */
  }

  .v-select {
    overflow: unset;
  }

  #modulesTable {
      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        > span {
          padding-inline-end: 30px;
          width: calc(100% - 200px);
        }
      }
  }

  #profilerow {
    align-items: center;
  }

  .text {
    border-radius: 50%;
    color: rgb(41, 41, 41);
    font-size: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    text-align: center;
    text-shadow: 2px 2px 5px rgb(255, 255, 255);
  }

  .profile-container {
    position: relative;
    width: 50%;
    border-radius: 50%;
    text-align: -webkit-center !important;
    text-align: -moz-center;

    &:hover .overlay {
      opacity: 1;
      border-radius: 50%;
    }
  }

  .overlay {
    border-radius: 50%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    transition: .5s ease;
  }

  .cropper-div {
    input[type="file"] {
      display: none;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0 5px 0;
    }
    .header h2 {
      margin: 0;
    }
    .header a {
      text-decoration: none;
      color: black;
    }
    .cropper-area_tool {
      width: 60%;
    }
    .cropper-area_buttons {
      width: 100%;
    }
    .actions {
      margin-top: 1rem;
      display: flex;
    }
    // .actions vs-button {
      
    //   padding: 5px 15px;
    //   background: #0062CC;
    //   color: white;
    //   text-decoration: none;
    //   border-radius: 3px;
    //   margin-right: 1rem;
    //   margin-bottom: 1rem;
    // }
    textarea {
      width: 100%;
      height: 100px;
    }
    .preview-area {
      width: 307px;
    }
    .preview-area p {
      font-size: 1.25rem;
      margin: 0;
      margin-bottom: 1rem;
    }
    .preview-area p:last-of-type {
      margin-top: 1rem;
    }
    .preview {
      width: 100%;
      height: calc(372px * (9 / 16));
      overflow: hidden;
    }
    .crop-placeholder {
      width: 100%;
      height: 200px;
      background: #ccc;
    }
    .cropped-image img {
      max-width: 100%;
    }
  }
</style>
